import { __awaiter } from "tslib";
import { SessionStore } from "./fns.store";
import axios from "axios";
export const getLinks = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const links = (_a = SessionStore.get("phx-links")) !== null && _a !== void 0 ? _a : null;
        if (links) {
            return links;
        }
        else {
            const resp = yield axios.get("/cdn/links.json");
            const data = resp.data;
            SessionStore.set("phx-links", data);
            return data;
        }
    }
    catch (e) {
        throw e;
    }
});
export function getLinkList() {
    return __awaiter(this, void 0, void 0, function* () {
        const links = yield getLinks();
        return [...links.WORKSPACE, ...links.PUBLIC];
    });
}
